import { render, staticRenderFns } from "./CartaoDebito.vue?vue&type=template&id=54aff350&scoped=true&"
import script from "./CartaoDebito.vue?vue&type=script&lang=js&"
export * from "./CartaoDebito.vue?vue&type=script&lang=js&"
import style0 from "./CartaoDebito.vue?vue&type=style&index=0&id=54aff350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aff350",
  null
  
)

export default component.exports